import type { FC } from 'react';

import { httpPostSearch } from '@iconik-io/iconik-api/src/services/search';
import { OBJECT_TYPE_COLLECTIONS } from '@iconik-io/iconik-api/src/types/object_types';

import { useAppDispatch } from '../../../../store/react_redux_typed';
import { prepareQueryParameter } from '../../../../utils/search_utils/search_utils';
import type { SelectOption } from '../../../select_field/types';
import {
  type LoadOptionsResult,
  resolveRemoteResponse,
} from '../../../select_field/utils';
import SelectFieldWrapper, {
  type SelectFieldWrapperProps,
} from '../select/select';

export const SelectCollectionsFieldWrapper: FC<SelectFieldWrapperProps> = (
  props,
) => {
  const dispatch = useAppDispatch();

  const handleLoadOptions = (query: string): Promise<LoadOptionsResult> =>
    dispatch(
      httpPostSearch(
        {
          query: prepareQueryParameter(query, { escapeMinus: true }),
          doc_types: [OBJECT_TYPE_COLLECTIONS],
          filter: {
            operator: 'AND',
            terms: [{ name: 'status', value: 'ACTIVE' }],
          },
        },
        {
          per_page: 20,
          save_search_history: false,
        },
      ),
    ).then(
      resolveRemoteResponse((response) =>
        response.body.objects.map((object) => ({
          value: object.id,
          label: object.title,
        })),
      ),
    );

  const handleLoadSelectedOptions = (ids: string[]): Promise<SelectOption[]> =>
    dispatch(
      httpPostSearch(
        {
          doc_types: [OBJECT_TYPE_COLLECTIONS],
          filter: {
            operator: 'AND',
            terms: [
              { name: 'id', value_in: ids },
              { name: 'status', value: 'ACTIVE' },
            ],
          },
        },
        {
          save_search_history: false,
        },
      ),
    ).then((response) =>
      response.body.objects.map((object) => ({
        value: object.id,
        label: object.title,
      })),
    );

  return (
    <SelectFieldWrapper
      {...props}
      preloadOptions
      loadOptions={handleLoadOptions}
      loadSelectedOptions={handleLoadSelectedOptions}
    />
  );
};

export default SelectCollectionsFieldWrapper;
